import request from '@/utils/request'

// 获取BioRender配置
export function getBioRenderConfig() {
  return request({
    url: '/api/admin/config/biorender',
    method: 'get'
  })
}

// 更新BioRender配置
export function updateBioRenderConfig(data) {
  return request({
    url: '/api/admin/config/biorender',
    method: 'post',
    data
  })
}

// ==================== BioRender管理员账户管理API ====================

// 分页查询管理员账户
export function getAdminAccountPage(params) {
  return request({
    url: '/api/admin/accounts',
    method: 'get',
    params
  })
}

// 根据ID查询管理员账户
export function getAdminAccountById(id) {
  return request({
    url: `/api/admin/accounts/${id}`,
    method: 'get'
  })
}

// 创建管理员账户
export function createAdminAccount(data) {
  return request({
    url: '/api/admin/accounts',
    method: 'post',
    data
  })
}

// 更新管理员账户
export function updateAdminAccount(id, data) {
  return request({
    url: `/api/admin/accounts/${id}`,
    method: 'put',
    data
  })
}

// 删除管理员账户
export function deleteAdminAccount(id) {
  return request({
    url: `/api/admin/accounts/${id}`,
    method: 'delete'
  })
}

// 批量删除管理员账户
export function batchDeleteAdminAccounts(ids) {
  return request({
    url: '/api/admin/accounts/batch',
    method: 'delete',
    data: ids
  })
}

// 设置激活账户
export function setActiveAccount(id) {
  return request({
    url: `/api/admin/accounts/${id}/activate`,
    method: 'post'
  })
}

// 获取当前激活账户
export function getCurrentActiveAccount(accountType) {
  return request({
    url: '/api/admin/accounts/current',
    method: 'get',
    params: {
      accountType: accountType || 'config'  // 默认为config类型
    }
  })
}

// 自动切换到下一个可用账户
export function switchToNextAvailableAccount(accountType) {
  return request({
    url: '/api/admin/accounts/switch',
    method: 'post',
    params: {
      accountType: accountType || 'config'  // 默认为config类型
    }
  })
}

// 批量导入管理员账户
export function bulkImportAdminAccounts(formData) {
  return request({
    url: '/api/admin/accounts/import',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 导出管理员账户
export function exportAdminAccounts() {
  return request({
    url: '/api/admin/accounts/export',
    method: 'get',
    responseType: 'blob'
  })
}

// 下载导入模板
export function downloadAdminTemplate() {
  return request({
    url: '/api/admin/accounts/template',
    method: 'get',
    responseType: 'blob'
  })
}

// 获取账户统计信息
export function getAccountStatistics() {
  return request({
    url: '/api/admin/accounts/statistics',
    method: 'get'
  })
}

// 增加管理员账户的激活用户数量（内部接口）
export function incrementActivatedUsers(id) {
  return request({
    url: `/api/admin/accounts/${id}/increment`,
    method: 'post'
  })
}